import { render } from "./DeptLocationBar.vue?vue&type=template&id=6aa0dbe1"
import script from "./DeptLocationBar.vue?vue&type=script&lang=js"
export * from "./DeptLocationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__